<template>
  <div class="tabs-container">
    <div class="tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="tab"
        class="tab px-2 py-1 text-body-color"
        :class="{ active: modelValue === tab }"
        @click="selectTab(tab, index)"
      >
        {{ tab }}
      </div>
    </div>
    <div
      class="indicator"
      :style="indicatorStyle"
    />
  </div>
</template>

<script setup>
import {
  ref,
  watchEffect,
  onMounted,
  computed,
  nextTick,
  defineProps,
  defineEmits,
} from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  tabs: Array,
});

const emit = defineEmits(['update:modelValue']);
const selectedIndex = ref(props.tabs.indexOf(props.modelValue));
const tabWidths = ref([]);
const tabOffsets = ref([]);

const indicatorStyle = computed(() => ({
  width: `${tabWidths.value[selectedIndex.value] || 0}px`,
  transform: `translateX(${tabOffsets.value[selectedIndex.value] || 0}px)`,
  transition: 'transform 0.3s ease',
}));

const updateTabMeasurements = () => {
  const tabsEl = document.querySelectorAll('.tab');
  tabWidths.value = Array.from(tabsEl).map((el) => el.offsetWidth);
  tabOffsets.value = Array.from(tabsEl).map((el, index) => {
    let offset = 0;
    for (let i = 0; i < index; i++) {
      offset += tabsEl[i].offsetWidth;
    }
    return offset;
  });
};

const selectTab = (tab, index) => {
  selectedIndex.value = index;
  emit('update:modelValue', tab);
};

onMounted(() => {
  updateTabMeasurements();
  if (props.modelValue === '') {
    selectTab(props.tabs[0], 0);
  }
});

watchEffect(() => {
  nextTick(updateTabMeasurements);
});
</script>

<style scoped>
.tabs-container {
  position: relative;
}

.tabs {
  display: flex;
}

.tab {
  cursor: pointer;
  transition: color 0.3s ease;
}

.indicator {
  position: absolute;
  bottom: -1px; /* Ajusta según sea necesario */
  height: 2px;
  background-color: #f8c617;
  transition: transform 0.3s ease;
}

.active {
  color: #f8c617; /* Ajusta el color según sea necesario */
  font-weight: 600;
  transition: color 0.1s ease;
}
</style>
